<template>
    <model-context-menu
        :model-class="modelClass"
        ref="contextMenu"
    >
        <template v-slot:default="slotProps">
            <model-actions :model="slotProps.model" @close="$refs.contextMenu.close" />
        </template>
    </model-context-menu>
</template>

<script>
    import ModelContextMenu from '@spa/apps/trustup-pro-base-js/components/Model/ContextMenu';
    import CalendarEvent from '@spa/apps/trustup-pro-planning-js/models/CalendarEvent';
    import ModelActions from './Actions';
    
    export default {
        components: {
            ModelContextMenu,
            ModelActions
        },

        data() {
            return {
                modelClass: CalendarEvent
            }
        }
    }
</script>